var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statisticalChartsContainer"},[_c('div',{staticClass:"chartItem"},[_c('div',{staticClass:"itemBox"},[_c('div',{staticClass:"chartBox"},[_c('echarts',{attrs:{"chart-id":_vm.idName,"chart-option":_vm.options}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }